import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";
import { IReport6RiskCriteria } from "./Report6RiskCriteria";

export interface TReport6Report {
  id: number;
  version: number;
  submitReason: string;
  submitDate: Date;
  regularEvaluationStatus: string;
  regularEvaluationDate: Date;
  reportingPeriodId: number;
  formalEvaluationStatus: string;
  formalEvaluationDate: Date;
  financialImbalance: boolean;
  applicantReportingPeriodId: number;
  reportTypeCode: string;
  reportTypeName: string;
}

export interface IReport6Report extends TReport6Report {
  riskCriterias: IReport6RiskCriteria[];
}

const Report6Report = Model(
  (model: TReport6Report): IReport6Report => {
    const _report6Report: TReport6Report = Object.assign({}, model);

    let create = (Report6Report: IReport6Report): IReport6Report => {
      let obj = ValidatableObject(Report6Report);
      return obj;
    };

    let _riskCriterias: IReport6RiskCriteria[] = [];

    let Report6Report = {
      get id() {
        return _report6Report.id;
      },
      set id(value) {
        _report6Report.id = value;
      },
      get version() {
        return _report6Report.version;
      },
      set version(value) {
        _report6Report.version = value;
      },
      get submitReason() {
        return _report6Report.submitReason;
      },
      set submitReason(value) {
        _report6Report.submitReason = value;
      },
      get submitDate() {
        return _report6Report.submitDate;
      },
      set submitDate(value) {
        _report6Report.submitDate = value;
      },
      get regularEvaluationStatus() {
        return _report6Report.regularEvaluationStatus;
      },
      set regularEvaluationStatus(value) {
        _report6Report.regularEvaluationStatus = value;
      },
      get regularEvaluationDate() {
        return _report6Report.regularEvaluationDate;
      },
      set regularEvaluationDate(value) {
        _report6Report.regularEvaluationDate = value;
      },
      get riskCriterias() {
        return _riskCriterias;
      },
      set riskCriterias(value) {
        _riskCriterias = value;
      },
      get reportingPeriodId() {
        return _report6Report.reportingPeriodId;
      },
      set reportingPeriodId(value) {
        _report6Report.reportingPeriodId = value;
      },
      get formalEvaluationStatus() {
        return _report6Report.formalEvaluationStatus;
      },
      set formalEvaluationStatus(value) {
        _report6Report.formalEvaluationStatus = value;
      },
      get formalEvaluationDate() {
        return _report6Report.formalEvaluationDate;
      },
      set formalEvaluationDate(value) {
        _report6Report.formalEvaluationDate = value;
      },
      get financialImbalance() {
        return _report6Report.financialImbalance;
      },
      set financialImbalance(value) {
        _report6Report.financialImbalance = value;
      },
      get applicantReportingPeriodId() {
        return _report6Report.applicantReportingPeriodId;
      },
      set applicantReportingPeriodId(value) {
        _report6Report.applicantReportingPeriodId = value;
      },
      get reportTypeCode() {
        return _report6Report.reportTypeCode;
      },
      set reportTypeCode(value) {
        _report6Report.reportTypeCode = value;
      },
      get reportTypeName() {
        return _report6Report.reportTypeName;
      },
      set reportTypeName(value) {
        _report6Report.reportTypeName = value;
      }
    };
    return create(Report6Report);
  }
);
export default Report6Report;
